module.exports = __webpack_public_path__ + "static/media/moreactions.1aa5f719.svg";